import { Injectable } from "@angular/core";
import { HttpService } from "../../../core/shared/http.service";
import { Observable } from "rxjs";
import { ChangelogDeviceFilter } from "../interfaces/changelog-device-filter.interface";
import { ChangelogGroupFilter } from "../interfaces/changelog-group-filter.interface";
import { ChangelogProjectFilter } from "../interfaces/changelog-project-filter.interface";
import { Changelog } from "../interfaces/changelog.interface";
import { EngineChangelog } from "../interfaces/changelogEngine.interface";
import { ChangelogAqReport } from "../interfaces/changelog-aq-report";
import { ChangelogSWAReport } from "../interfaces/changelog-swa-report";
import { LogBaseFilter } from "../interfaces/log-base-filter";
import { MQResult } from "src/app/project/shared/interfaces/mqresult.interface";

@Injectable({
    providedIn: 'root'
})
export class EngineService {

    constructor(private readonly httpService: HttpService) { }

    public getChangelogDevice(deviceFilter: ChangelogDeviceFilter): Observable<Changelog[]> {

        return this.httpService.post<Changelog[]>('Engine/Changelog/device', deviceFilter);
    }

    public getChangelogGroup(groupFilter: ChangelogGroupFilter): Observable<Changelog[]> {

        return this.httpService.post<Changelog[]>('Engine/Changelog/group', groupFilter);
    }

    public getChangelogProject(projectFilter: ChangelogProjectFilter): Observable<Changelog[]> {


        return this.httpService.post<Changelog[]>('Engine/Changelog/project', projectFilter);
    }

    public getChangelogGroupDownload(groupFilter: ChangelogGroupFilter): Observable<Blob> {
        return this.httpService.postBlob('Engine/Changelog/group', groupFilter);
    }

    public getChangelogProjectDownload(projectFilter: ChangelogProjectFilter): Observable<Blob> {
        return this.httpService.postBlob('Engine/Changelog/project', projectFilter);
    }

    public getChangelogRouteStationDownload(deviceFilter: ChangelogDeviceFilter): Observable<Blob> {
        return this.httpService.postBlob('Engine/Changelog/device', deviceFilter);
    }

    /* anderer widergabetyp? analog zu report/aq/device einbauen?  */
    public getEngineChangeLogMQDevice(deviceFilter: ChangelogDeviceFilter): Observable<EngineChangelog[]> {
        return this.httpService.post<EngineChangelog[]>('Engine/Changelog/MQ/device', deviceFilter);
    }

    public getEngineChangeLogMQGroup(groupFilter: ChangelogGroupFilter): Observable<EngineChangelog[]> {
        return this.httpService.post<EngineChangelog[]>('Engine/Changelog/MQ/group', groupFilter);
    }

    public getEngineChangeLogMQProject(projectFilter: ChangelogProjectFilter): Observable<EngineChangelog[]> {
        return this.httpService.post<EngineChangelog[]>('Engine/Changelog/MQ/project', projectFilter);
    }

    public getEngineChangeLogMQDeviceDownload(deviceFilter: ChangelogDeviceFilter): Observable<Blob> {
        return this.httpService.postBlob('Engine/Changelog/MQ/device', deviceFilter);
    }

    public getEngineChangeLogMQGroupDownload(groupFilter: ChangelogGroupFilter): Observable<Blob> {
        return this.httpService.postBlob('Engine/Changelog/MQ/group', groupFilter);
    }

    public getEngineChangeLogMQProjectDownload(projectFilter: ChangelogProjectFilter): Observable<Blob> {
        return this.httpService.postBlob('Engine/Changelog/MQ/project', projectFilter);
    }

    /*     public getEngineChangeLogAQDevice(deviceFilter: ChangelogDeviceFilter): Observable<ChangelogAqReport[]> {
            deviceFilter.from = this.toLocalTime(deviceFilter.from)
            deviceFilter.to = this.toLocalTime(deviceFilter.to)
            return this.httpService.post<ChangelogAqReport[]>('Engine/Changelog/AQ/device', deviceFilter);
        }
    
        public getEngineChangeLogAQGroup(groupFilter: ChangelogGroupFilter): Observable<ChangelogAqReport[]> {
            groupFilter.from = this.toLocalTime(groupFilter.from)
            groupFilter.to = this.toLocalTime(groupFilter.to)
            return this.httpService.post<ChangelogAqReport[]>('Engine/Changelog/AQ/group', groupFilter);
        }
    
        public getEngineChangeLogAQProject(projectFilter: ChangelogProjectFilter): Observable<ChangelogAqReport[]> {
            projectFilter.from = this.toLocalTime(projectFilter.from)
            projectFilter.to = this.toLocalTime(projectFilter.to)
            return this.httpService.post<ChangelogAqReport[]>('Engine/Changelog/AQ/project', projectFilter);
        }
    
        public getEngineChangeLogAQDeviceDownload(deviceFilter: ChangelogDeviceFilter): Observable<Blob> {
            deviceFilter.from = this.toLocalTime(deviceFilter.from)
            deviceFilter.to = this.toLocalTime(deviceFilter.to)
            return this.httpService.postBlob('Engine/Changelog/AQ/device', deviceFilter);
        }
    
        public getEngineChangeLogAQGroupDownload(groupFilter: ChangelogGroupFilter): Observable<Blob> {
            groupFilter.from = this.toLocalTime(groupFilter.from)
            groupFilter.to = this.toLocalTime(groupFilter.to)
            return this.httpService.postBlob('Engine/Changelog/AQ/group', groupFilter);
        }
    
        public getEngineChangeLogAQProjectDownload(projectFilter: ChangelogProjectFilter): Observable<Blob> {
            projectFilter.from = this.toLocalTime(projectFilter.from)
            projectFilter.to = this.toLocalTime(projectFilter.to)
            return this.httpService.postBlob('Engine/Changelog/AQ/project', projectFilter);
        } */

    public getEngineChangeLogSWADevice(deviceFilter: ChangelogDeviceFilter): Observable<ChangelogSWAReport[]> {
        return this.httpService.post<ChangelogSWAReport[]>('Engine/Changelog/SWA/device', deviceFilter);
    }

    public getEngineChangeLogSWAGroup(groupFilter: ChangelogGroupFilter): Observable<ChangelogSWAReport[]> {
        return this.httpService.post<ChangelogSWAReport[]>('Engine/Changelog/SWA/group', groupFilter);
    }

    public getEngineChangeLogSWAProject(projectFilter: ChangelogProjectFilter): Observable<ChangelogSWAReport[]> {
        return this.httpService.post<ChangelogSWAReport[]>('Engine/Changelog/SWA/project', projectFilter);
    }

    public getEngineChangeLogSWADeviceDownload(deviceFilter: ChangelogDeviceFilter): Observable<Blob> {
        return this.httpService.postBlob('Engine/Changelog/SWA/device', deviceFilter);
    }

    public getEngineChangeLogSWAGroupDownload(groupFilter: ChangelogGroupFilter): Observable<Blob> {
        return this.httpService.postBlob('Engine/Changelog/SWA/group', groupFilter);
    }

    public getEngineChangeLogSWAProjectDownload(projectFilter: ChangelogProjectFilter): Observable<Blob> {
        return this.httpService.postBlob('Engine/Changelog/SWA/project', projectFilter);
    }

    public getSchaltentscheidReport(deviceFilter: LogBaseFilter): Observable<any[]> {
        return this.httpService.post<any[]>('Engine/Changelog/AQEngine', deviceFilter);
    }

    public getSchaltentscheidReportAsDownload(deviceFilter: LogBaseFilter): Observable<Blob> {
        return this.httpService.postBlob('Engine/Changelog/AQEngine', deviceFilter);
    }


    public getEngineChangeLogMQEngine(deviceFilter: LogBaseFilter): Observable<EngineChangelog[]> {
        return this.httpService.post<EngineChangelog[]>('Engine/Changelog/MQEngine', deviceFilter);
    }

    public getEngineChangeLogMQEngineDownload(deviceFilter: LogBaseFilter): Observable<Blob> {
        return this.httpService.postBlob('Engine/Changelog/MQEngine', deviceFilter);
    }




}
